import type { MembershipApplicationStep } from "./types"

export const MEMBERSHIP_APPLICATION_BASE_PATH = "/membership/apply"

export const membershipApplicationSteps: MembershipApplicationStep[] = [
  {
    id: "category",
    title: "Category",
    description: "Select the membership category you are applying for.",
    path: `${MEMBERSHIP_APPLICATION_BASE_PATH}/category`,
  },
  {
    id: "profile",
    title: "Profile",
    description: "Fill in personal details",
    path: `${MEMBERSHIP_APPLICATION_BASE_PATH}/profile`,
  },
  {
    id: "requirements",
    title: "Requirements",
    description: "Complete category-specific requirements",
    path: `${MEMBERSHIP_APPLICATION_BASE_PATH}/requirements`,
  },
  // {
  //   id: "employment",
  //   title: "Employment History",
  //   description: "Record current and previous employment",
  //   path: `${MEMBERSHIP_APPLICATION_BASE_PATH}/employment`,
  // },
  // {
  //   id: "education",
  //   title: "Education",
  //   description: "List academic qualifications and training",
  //   path: `${MEMBERSHIP_APPLICATION_BASE_PATH}/education`,
  // },
  // {
  //   id: "affiliations",
  //   title: "Affiliations & Awards",
  //   description: "Capture professional bodies and recognitions",
  //   path: `${MEMBERSHIP_APPLICATION_BASE_PATH}/affiliations`,
  // },
  {
    id: "documents",
    title: "Supporting Documents",
    description: "Upload CV, IDs, and transcripts",
    path: `${MEMBERSHIP_APPLICATION_BASE_PATH}/documents`,
  },
  {
    id: "review",
    title: "Review & Submit",
    description: "Confirm details before submission",
    path: `${MEMBERSHIP_APPLICATION_BASE_PATH}/review`,
  },
]
